// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bhi_wv bhi_iz bhi_xj bhi_i bhi_j bhi_q bhi_vr bhi_er bhi_sm bhi_sn bhi_eb","CommentsButton__icon":"il_b bhi_rx"};